import { NbiDimensions } from "../../generic/generic-nbi-dimensions";

const attrs = new NbiDimensions();

const portfolioClientCountry = "Portfolio Client Country";
const portfolioClientId = "Portfolio Client Id";
const portfolioClientName = "Portfolio Client Name";
const portfolioClientLevel = "Portfolio Client Level";
const portfolioClientRegion = "Portfolio Client Region";
const portfolioClientSegment = "Portfolio Client Segment";
const portfolioClientSteeringCountry = "Portfolio Client Steering Country";
const portfolioClientSubRegion = "Portfolio Client Sub Region";

function GetClientGroupingAttributes() {
  return [
    {
      description: "Client Sub Group",
      example: "",
      id: attrs.SUB_GRP_FULL_NAME,
      name: "Client Sub Group",
    },
    {
      description: "Client Sub Group Id",
      example: "",
      id: attrs.SUB_GRP_ID,
      name: "Client Sub Group Id",
    },
    {
      description: "GLBA client group ID",
      example: "",
      id: attrs.CLIENT_CORIGRPCOMID,
      name: "GLBA client group ID",
    },
    {
      description: "GLBA client group name",
      example: "",
      id: attrs.CLIENT_CORIGRPNAME,
      name: "GLBA client group name",
    },
    {
      description: "Client RCT for Legal Entity",
      example: "",
      id: attrs.CLIENT_LE_RCT_CODE,
      name: "Client RCT for Legal Entity",
    },
  ];
}

export function getAllNbiAttributes() {
  return [
    {
      description: "Booking Country",
      example: "",
      id: attrs.BE_RES_CTRY_NAME,
      name: "Booking Country",
    },
    {
      description: "Booking Entity",
      example: "",
      id: attrs.BE_SHORT_LABEL,
      name: "Booking Entity",
    },
    {
      description: "Booking Place",
      example: "",
      id: attrs.AGENCY_DEC_LONG_NAME,
      name: "Booking Place",
    },
    {
      description: "Business Line",
      example: "",
      id: attrs.FPV_BL,
      name: "Business Line",
    },
    {
      description: "Client Group Id",
      example: "",
      id: attrs.CLIENT_GRPID,
      name: "Client Group Id",
    },
    {
      description: "Client Group Name",
      example: "",
      id: attrs.GRP_FULL_NAME,
      name: "Client Group Name",
    },
    {
      description: "Client Legal Entity",
      example: "",
      id: attrs.CLIENT_LENAME,
      name: "Client Legal Entity",
    },
    {
      description: "Client Legal Entity Id",
      example: "",
      id: attrs.CLIENT_LEID,
      name: "Client Legal Entity Id",
    },
    {
      description: "Client PCRU",
      example: "",
      id: attrs.CLIENT_PCRU,
      name: "Client PCRU",
    },
    {
      description:
        "Business Provider - Commercial Client (any level) Follow Up Class Short Label",
      example: "MARK, GLBA",
      id: attrs.CLIENT_SHORT_PCRU,
      name: "Client Short PCRU",
    },
    ...GetClientGroupingAttributes(),
    {
      description: "GLBA client lead banker",
      example: "",
      id: attrs.CLIENT_LEADCORIBANKER,
      name: "GLBA client lead banker",
    },
    {
      description: "Originating Country",
      example: "",
      id: attrs.OE_RES_CTRY_NAME,
      name: "Originating Country",
    },
    {
      description: "Originating Region",
      example: "",
      id: attrs.OE_RES_REG_CODE,
      name: "Originating Region",
    },
    {
      description: "Originating Entity",
      example: "",
      id: attrs.OE_SHORT_LABEL,
      name: "Originating Entity",
    },
    {
      description: portfolioClientCountry,
      example: "",
      id: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      name: portfolioClientCountry,
    },
    {
      description: portfolioClientId,
      example: "",
      id: attrs.CLIENT_GEN_ID,
      name: portfolioClientId,
    },
    {
      description: portfolioClientLevel,
      example: "",
      id: attrs.CLIENT_GEN_LEVEL,
      name: portfolioClientLevel,
    },
    {
      description: portfolioClientName,
      example: "",
      id: attrs.CLIENT_GEN_NAME,
      name: portfolioClientName,
    },
    {
      description: portfolioClientRegion,
      example: "",
      id: attrs.CLIENT_GEN_REG_NAME,
      name: portfolioClientRegion,
    },
    {
      description: portfolioClientSegment,
      example: "",
      id: attrs.CLIENT_GEN_SEGMENT,
      name: portfolioClientSegment,
    },
    {
      description: portfolioClientSteeringCountry,
      example: "",
      id: attrs.CLIENT_GEN_CTRY_AXIS_LABEL,
      name: portfolioClientSteeringCountry,
    },
    {
      description: portfolioClientSubRegion,
      example: "",
      id: attrs.CLIENT_GEN_SUB_REG_NAME,
      name: portfolioClientSubRegion,
    },
    {
      description: "Product Level 1",
      example: "",
      id: attrs.PRODUCT_LEVEL1,
      name: "Product Level 1",
    },
    {
      description: "Product Level 2",
      example: "",
      id: attrs.PRODUCT_LEVEL2,
      name: "Product Level 2",
    },
    {
      description: "Product Level 3",
      example: "",
      id: attrs.PRODUCT_LEVEL3,
      name: "Product Level 3",
    },
    {
      description: "Sales Location",
      example: "",
      id: attrs.SALESBEN_SALES_LOCATION,
      name: "Sales Location",
    },
    {
      description: "Sub Business Line",
      example: "",
      id: attrs.FPV_SBL,
      name: "Sub Business Line",
    },
    {
      description: "Sub Sub Business Line",
      example: "",
      id: attrs.FPV_SSBL,
      name: "Sub Sub Business Line",
    },
    {
      description: "Typology Level 1",
      example: "",
      id: attrs.CLIENT_GEN_TYPL1,
      name: "Typology Level 1",
    },
    {
      description: "Typology Level 2",
      example: "",
      id: attrs.CLIENT_GEN_TYPL2,
      name: "Typology Level 2",
    },
    {
      description: "Typology Level 3",
      example: "",
      id: attrs.CLIENT_GEN_TYPL3,
      name: "Typology Level 3",
    },
    { id: attrs.YEAR, name: "Year", description: "Year", example: "" },
    {
      description: "Month",
      example: "",
      id: attrs.CALENDAR_MONTH_LABEL,
      name: "Month",
    },
    {
      description: "Quarter",
      example: "",
      id: attrs.CALENDAR_QUARTER_LABEL,
      name: "Quarter",
    },
    {
      description: "NBI breakdown level 1",
      example: "",
      id: attrs.NBI_GBIS_LEVEL_1_FUNCTIONAL_LABEL,
      name: "NBI breakdown level 1",
    },
    {
      description: "NBI breakdown level 6",
      example: "",
      id: attrs.NBI_GBIS_LEVEL_6_FUNCTIONAL_LABEL,
      name: "NBI breakdown level 6",
    },
    {
      description: "NBI breakdown level 7",
      example: "",
      id: attrs.NBI_GBIS_LEVEL_7_FUNCTIONAL_LABEL,
      name: "NBI breakdown level 7",
    },
    {
      description: "Source Application",
      example: "",
      id: attrs.GBIS_FEEDER_APPNAME,
      name: "Source Application",
    },
    {
      description: "Supplier",
      example: "",
      id: attrs.GBIS_ORIGINAPP_APPNAME,
      name: "Supplier",
    },
    {
      description: "Product Label",
      example: "",
      id: attrs.PRODUCT_LABEL,
      name: "Product Label",
    },
    {
      description: "Product Code",
      example: "",
      id: attrs.PRODUCT_CODE,
      name: "Product Code",
    },
    {
      description: "Client RCT for legal entity",
      example: "",
      id: attrs.CLIENT_LE_RCT_CODE,
      name: "Client RCT for legal entity",
    },
  ];
}

export function getAllNbiKpis() {
  return [
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "nbi_nbi",
      name: "NBI",
      old_name: "NBI (K€)",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "nbi_rwa_avg",
      name: "RWA Avg",
      old_name: "RWA Avg(M€)",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "nbi_rwa_eop",
      name: "Stock RWA",
      old_name: "Stock RWA(M€)",
    },

    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "nb_legal_entities_nbi",
      name: "Nb of Legal entities",
      old_name: "",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "nb_groups_nbi",
      name: "Nb of Groups",
      old_name: "",
    },
  ];
}